<section id="categories-section" class="feat-pro2 pb-0" style="min-height: 240px">
  <div class="container px-0 pt-4">
    <div class="d-flex flex-column align-items-center">
      <section class="feat-pro2">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 col-md-8">
              <div class="row">
                <div class="col-md-12 padding-fix-l20">
                  <div class="ftr-product">
                    <!-- Tab panes -->
                    <div class="tab-content pb-4 pb-md-0">
                      <div class="tab-pane fade show active pb-4 pb-md-0" id="all" role="tabpanel">
                        <div class="tab-slider owl-carousel" id="category-slider">
                          <ng-container *ngFor="let cat of categories">
                            <div *ngIf="!cat.turnOff" class="tab-item"  style="border: transparent">
                              <div class="tab-img p-2 position-relative">
                                <div routerLink="{{cat.slug}}" class="d-flex justify-content-center align-items-center cursor-pointer" style="height: 0; padding-bottom: 100%">
                                  <img style="border-radius: 50rem" class="main-img img-fluid m-auto p-2" src="{{cat.src}}" alt="{{cat.alt}}">
                                </div>
                                <p *ngIf="cat.name == 'Walmart' || cat.name == 'Home Depot' || cat.name == 'Best Buy'" style="top: 5px; right: 0; padding: 1px 22px; height: 21px" class="bg-danger rounded-pill text-white px-1 mb-0 position-absolute d-flex"><small >Nuevo</small></p>
                              </div>
                              <div class="tab-heading">
                                <p routerLink="{{cat.slug}}" class="text-center cursor-pointer">{{cat.name}}</p>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
